$(document).ready(function () {
  const $form = $(".cancellation-form")

  if ($form.length < 1) {
    return
  }

  const $options = $form.find(".cancellation-reasons .pseudo-checkbox--input")
  const $optionsError = $form.find(".booking--conditions--invalid")
  const $cancelButtons = $(".js-cancel-buttons")
  const $modifyButton = $(".js-modification-button")
  const $confirmationContainer = $(".cancellation-confirmation")
  const $confirmationWarning = $(".cancellation-confirmation__warning")
  const $confirmationBlock = $confirmationContainer.add($confirmationWarning)
  const $confirmationInput = $confirmationContainer.find(
    ".pseudo-checkbox--input",
  )
  const $confirmationError = $(".cancellation-confirmation--error")
  const finalConfirmationTemplate = document.getElementById(
    "cancellation-final-confirmation-template",
  )
  const $finalConfirmationPopup = $("#popup_modal")

  function isOptionChecked() {
    return $options.filter(":checked").length > 0
  }

  function isConfirmationChecked() {
    return $confirmationInput.length ? $confirmationInput.is(":checked") : true
  }

  function shouldShowFinalConfirmation() {
    const formElement = $form.get(0)
    const finalConfirmationAccepted =
      formElement?.dataset.finalConfirmationAccepted === "true"

    return (
      !finalConfirmationAccepted &&
      finalConfirmationTemplate &&
      $finalConfirmationPopup.length
    )
  }

  function showFinalConfirmation() {
    if (!finalConfirmationTemplate || !$finalConfirmationPopup.length) {
      return
    }

    const drawerTrigger = document.querySelector(
      '[data-template="cancellation-final-confirmation-drawer-template"]',
    )
    if (HB?.isMobile && drawerTrigger && HB.drawerOpen) {
      HB.drawerOpen(drawerTrigger)
      return
    }

    $finalConfirmationPopup.html(finalConfirmationTemplate.innerHTML)
  }

  $form.on("submit", function (e) {
    if (isOptionChecked() && isConfirmationChecked()) {
      return
    }

    e.preventDefault()

    if (!isOptionChecked()) {
      $optionsError.removeClass("booking--conditions--invalid_hidden")
    }

    if (!isConfirmationChecked()) {
      $confirmationError.removeClass("hidden")
      $confirmationContainer.addClass("pseudo-checkbox_error")
    }

    if (!isOptionChecked()) {
      return Viewport.scrollTo($(".cancellation-reasons"))
    }

    if (!isConfirmationChecked()) {
      return Viewport.scrollTo($(".cancellation-confirmation"))
    }
  })

  $options.on("change", function (e) {
    $optionsError.toggleClass(
      "booking--conditions--invalid_hidden",
      isOptionChecked(),
    )

    $(".cancellation-reasons--i textarea").prop("required", false)

    const $currentOption = $(e.target)
    const $closestTextarea = $currentOption
      .closest(".cancellation-reasons--i")
      .find("textarea")

    if ($closestTextarea.length && $currentOption.is(":checked")) {
      $closestTextarea.prop("required", true)
    }
  })

  $confirmationInput.on("change", function () {
    $confirmationContainer.toggleClass(
      "pseudo-checkbox_error",
      !isConfirmationChecked(),
    )

    $confirmationError.toggleClass("hidden", isConfirmationChecked())
  })

  $(".cancellation-reasons--i").on("change", function () {
    const alias = $(this).find(".pseudo-checkbox--input").data("alias")
    const allowedToModify =
      $(this).find(".pseudo-checkbox--input").data("allowed-to-modify") !==
      undefined

    if (alias === "change_dates" && allowedToModify) {
      $modifyButton.removeClass("hidden")
      $cancelButtons.addClass("hidden")
      $confirmationBlock.addClass("hidden")
    } else {
      $modifyButton.addClass("hidden")
      $cancelButtons.removeClass("hidden")
      $confirmationBlock.removeClass("hidden")
    }
  })

  $form.on("submit", function (e) {
    if (isOptionChecked() && isConfirmationChecked()) {
      if (shouldShowFinalConfirmation()) {
        e.preventDefault()
        showFinalConfirmation()
        return
      }

      $(this)
        .find(".btn_danger.checkout-btn")
        .addClass("btn_loading")
        .attr("disabled", true)
    }
  })
})
